import { TYPOGRAPHY } from "@store/theme/design";
import { inputStyles } from "@store/theme/mixins";
import { css } from "styled-components";

export default {
    defaultProps: {
        iconProps: {
            css: css`
                background: transparent !important;
            `,
        },
    },
};
